import request from '../utils/request';
import { IOneGallery, IOneGalleryBase } from '../components/GalleryList/Common';
import instance from '../components/VideoV2/Manager';
export interface IImageListResult {
  data: IOneGallery[];
  total: number;
}
interface IImageList {
  sorttype: string;
  order: string;
  galleryid: number;
  lasttime?: number | null;
  tag?: string;
  offset?: number;
  galleryids?: number[] | string[];
}

const imageListCanUseCache = (galleryid: number | string) => {
  let time = Number(window.localStorage.getItem(`image_t_${galleryid}`) || 0);
  if (Date.now() - time > 2 * 60 * 1000) {
    return false;
  } else {
    if (Number(window.localStorage.getItem(`image_message_${galleryid}`)) > 0) {
      return true;
    } else {
      return false;
    }
  }
};

const setImageListCanUseCache = (galleryid: number | string) => {
  let time = Number(window.localStorage.getItem(`image_t_${galleryid}`) || 0);
  if (Date.now() - time > 2 * 60 * 1000) {
    window.localStorage.removeItem(`image_message_${galleryid}`);
    window.localStorage.setItem(`image_t_${galleryid}`, Date.now() + '');
  }
};

const image = {
  tagList: ({
    sorttype = '',
    order = 'desc',
    galleryid = 0,
    lasttime = 0,
    tag = '',
    offset = 0,
    galleryids
  }: IImageList) => {
    if (lasttime === null) {
      if (order === 'asc') {
        lasttime = 0;
      } else {
        lasttime = Number.MAX_SAFE_INTEGER;
      }
    }

    const useNoCache = (lasttime == 0 || lasttime == Number.MAX_SAFE_INTEGER);

    const noCacheQuery = useNoCache
      ? `&_t=${Math.round(Date.now() / 1000)}`
      : ``;

    return new Promise<IImageListResult>((resolve, reject) => {
      request({
        method: 'post',
        contentType: 'json',
        data: {
          galleryids,
          // sorttype=${ sorttype } & order=${ order } & offset=${ offset } & tags=${ tag }
          sorttype,
          order,
          offset,
          tags: tag
        },
        url: `/api/v2/images/taglist?${noCacheQuery}`,
        // url: `/api/image/list?sorttype=${sorttype}&order=${order}&offset=${offset}&tag=${tag}&lasttime=${lasttime}&galleryid=${galleryid}`
        headers: useNoCache
          ? {
            'Cache-Control': 'no-cache'
          }
          : null
      })
        .then(res => {
          if (res && res.pagedata) {
            try {
              res.pagedata = JSON.parse(res.pagedata);
            } catch (e) {
              res.pagedata = {};
            }
          }
          res = res.data;
          res.data = res.items;

          setImageListCanUseCache(galleryid);

          resolve(res);
        })
        .catch(reject);
    });
  },
  // Number.MAX_SAFE_INTEGER
  list: ({
    sorttype = '',
    order = 'desc',
    galleryid = 0,
    lasttime = 0,
    tag = '',
    offset = 0
  }: IImageList) => {
    if (lasttime === null) {
      if (order === 'asc') {
        lasttime = 0;
      } else {
        lasttime = Number.MAX_SAFE_INTEGER;
      }
    }

    const useNoCache =
      imageListCanUseCache(galleryid) &&
      (lasttime == 0 || lasttime == Number.MAX_SAFE_INTEGER);

    const noCacheQuery = useNoCache
      ? `&_t=${Math.round(Date.now() / 1000)}`
      : ``;

    return new Promise<IImageListResult>((resolve, reject) => {
      request({
        url: `/api/v2/images/${galleryid}/list?sorttype=${sorttype}&order=${order}&offset=${offset}&tags=${tag}${noCacheQuery}`,
        // url: `/api/image/list?sorttype=${sorttype}&order=${order}&offset=${offset}&tag=${tag}&lasttime=${lasttime}&galleryid=${galleryid}`
        headers: useNoCache
          ? {
            'Cache-Control': 'no-cache'
          }
          : null
      })
        .then(res => {
          if (res && res.pagedata) {
            try {
              res.pagedata = JSON.parse(res.pagedata);
            } catch (e) {
              res.pagedata = {};
            }
          }
          res = res.data;
          res.data = res.items;

          setImageListCanUseCache(galleryid);

          resolve(res);
        })
        .catch(reject);
    });
  },
  batchlist: async (ids: string | (string | number)[]) => {
    const id = ids instanceof Array ? ids.join(',') : ids;
    const res = await request({
      url: `/api/v2/images/batchlist?id=${id}`
    });
    return res?.data as IOneGalleryBase[];
  },

  size: (url: string) => {
    return new Promise((resolve, reject) => {
      request({
        url: `/api/v2/images/size?url=${encodeURIComponent(url)}`
      })
        .then(res => {
          if (res && res.size) {
            resolve(res.size);
          } else {
            resolve(0);
          }
        })
        .catch(reject);
    });
  },
  ocr: (keyword = '', galleryid: number) => {
    return new Promise((resolve, reject) => {
      request({
        url: `/api/ocr/search?galleryid=${galleryid}&keyword=${keyword}`
      })
        .then(res => {
          resolve(res || []);
        })
        .catch(reject);
    });
  },
  uploadImage: (gallery_id: string | number, hash: string, keywords?: string, tags?: string) => {
    return new Promise((resolve, reject) => {
      request({
        url: `/api/v2/images/upload`,
        method: 'post',
        headers: {
          Authorization: request.token
        },
        data: {
          gallery_id,
          hash,
          keywords,
          tags,
          link_id: window.pageDetail.link_id
        }
      }).then(res => {
        resolve(res);
      }).catch(reject);
    });
  },
  getImageById: (ids: string | string[]) => {
    return new Promise((resolve, reject) => {
      request({
        url: `/api/v2/images/batchlist`,
        method: 'get',
        data: {
          id: ids
        }
      }).then(resolve).catch(reject);
    })
  }
};

export default image;
